import { SegmentedControl } from 'ui/segmentedControl';
import { DCB_MODES } from '../constants';
import { useTranslation } from '../hooks/useTranslation';

export const ConditionBuilderSegmentedControl = ({
  mode,
  setMode,
}: { mode: DCB_MODES; setMode: (newMode: DCB_MODES) => void }) => {
  const { t } = useTranslation();

  return (
    <SegmentedControl
      isFullWidth
      onSelect={(newValue) => {
        setMode(newValue);
      }}
      options={[
        {
          name: t('controls.assisted.name'),
          tooltip: {
            content: t('controls.assisted.tooltip'),
          },
          value: DCB_MODES.ASSISTED,
        },
        {
          name: t('controls.manual.name'),
          tooltip: {
            content: t('controls.manual.tooltip'),
          },
          value: DCB_MODES.MANUAL,
        },
      ]}
      value={mode}
    />
  );
};
